<h1 mat-dialog-title>Change Consignee</h1>
<div mat-dialog-content>
  <form [formGroup]="consigneeForm">
    <mat-form-field style="width: 100%;">
      <mat-label>New Consignee</mat-label>
      <input
        type="text"
        matInput
        formControlName="new_consignee_control"
        [matAutocomplete]="auto"
        placeholder="Type at least 3 letters"
      />
      <mat-autocomplete
        #auto="matAutocomplete"
        [displayWith]="displayFn"
        (optionSelected)="onConsigneeSelected($event.option.value)"
      >
        <mat-option *ngFor="let consignee of filteredConsigneeList | async" [value]="consignee">
          {{ consignee.label }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <mat-form-field style="width: 100%;" *ngIf="addresses.length > 0">
      <mat-label>Select Address</mat-label>
      <mat-select formControlName="consignee_address_uuid">
        <mat-option *ngFor="let address of addresses" [value]="address.contact_address_uuid">
          {{ address.address || 'No address' }}, {{ address.locality || 'No locality' }}, {{ address.region || 'No region' }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </form>
</div>
<div mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-button color="primary" (click)="onSubmit()">Submit</button>
</div>